export default "__VITE_ASSET__65cfd4be__"